import { render, staticRenderFns } from "./USU001_vistaInicio.vue?vue&type=template&id=1ba67fba&scoped=true&"
import script from "./USU001_vistaInicio.vue?vue&type=script&lang=js&"
export * from "./USU001_vistaInicio.vue?vue&type=script&lang=js&"
import style0 from "./USU001_vistaInicio.vue?vue&type=style&index=0&id=1ba67fba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba67fba",
  null
  
)

export default component.exports